import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LabelAndValue } from '../../../global/components/data-display/label-value';
import { GuidedProcessSupportBlock } from '../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { SideBarContent } from '../../../global/components/layout/sidebar-content';
import { TcsmModal } from '../../../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getPodsContent } from '../../../global/ducks/epi-api';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { MyCpgPodsSettings, PodContent, RsvpData } from '../mycpg-pod-models';


interface Props {
	settings: MyCpgPodsSettings;
}
export function RsvpPlanDetail(props: Props) {

	const { settings } = props;
	const rsvpPlan = useSelector<TcsmStates, RsvpData>(state => state?.mycpgPodsState?.pods?.rsvp_data);
	const [content, setContent] = useState<any>('');
	const dispatch = useDispatch();
	const [open, setOpen] = React.useState(false);
	const notEnrolled = rsvpPlan?.content === PodContent.NOT_ENROLLED;
	const [fidelity, setfidelity] = useState<any>('');
	useEffect(() => {
		if (rsvpPlan?.data?.plan_details) {
			dispatch(getPodsContent(rsvpPlan?.data?.plan_details, (data) => setContent(data?.contentHtml)));
		}
		if (rsvpPlan?.data?.fidelity_link_path) {
			dispatch(getPodsContent(rsvpPlan?.data?.fidelity_link_path, (data) => setfidelity(data?.contentHtml)));
		}
	}, []);


	if (rsvpPlan?.show_pod === YesNoIndicators.No || !rsvpPlan?.data) {
		return null;
	}

	const handleClose = () => {
		setOpen(false);
	};

	const renderDetailSection = () => {

		if (notEnrolled) {
			return (
				<DividerSection removeDivider>
					<WysiwygWithReactLink content={settings?.rsvpPlanNotEnrolledMessage} />
				</DividerSection>
			);
		}

		return (
			<>
				<TcsmModal
					open={open}
					handleClose={handleClose}
				>
					<WysiwygWithReactLink content={content} />
				</TcsmModal>
				<DividerSection removeDivider sectionText={settings?.rsvpFidelityTitle}>
					<ContentSpacer>
						<p className='h3-styled'>{getCurrencyFormat(rsvpPlan?.data?.total_balance)}</p>
						<p className='grey-caption'>{settings?.balanceDateLabel?.replace('{date}', rsvpPlan?.data?.as_of_date)}</p>
					</ContentSpacer>
					{rsvpPlan?.data?.status && <LabelAndValue label={settings?.statusLabel} value={<p className={rsvpPlan?.data?.status === 'Active' ? 'green-text' : 'red-text'}><strong>{rsvpPlan?.data?.status}</strong></p>} />}
					{rsvpPlan?.employer_base === YesNoIndicators.Yes && <LabelAndValue label={settings?.employerBaseLabel} tooltipMessage={settings?.employerBaseHelper} value={rsvpPlan?.data?.employer_base === 'N/A' ? rsvpPlan?.data?.employer_base : `${rsvpPlan?.data?.employer_base}%`} />}
					{rsvpPlan?.employer_match === YesNoIndicators.Yes && <LabelAndValue label={settings?.employerMatchLabel} tooltipMessage={settings?.employerMatchHelper} value={rsvpPlan?.data?.employer_match === 'N/A' ? rsvpPlan?.data?.employer_match : `${rsvpPlan?.data?.employer_match}%`} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.deferralAmountLabel} tooltipMessage={settings?.deferralAmountHelper} value={getCurrencyFormat(rsvpPlan?.data?.benefit_pretax_amount)} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.deferralPercentLabel} tooltipMessage={settings?.deferralPercentHelper} value={`${rsvpPlan?.data?.benefit_pretax_percent}%`} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.rothDeferralAmountLabel} tooltipMessage={settings?.rothDeferralAmountTooltip} value={getCurrencyFormat(rsvpPlan?.data?.benefit_roth_amount)} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.rothDeferralPercentLabel} tooltipMessage={settings?.rothDeferralPercentTooltip} value={`${rsvpPlan?.data?.benefit_roth_percent}%`} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.afterTaxDeferralAmountLabel} tooltipMessage={settings?.afterTaxDeferralAmountTooltip} value={getCurrencyFormat(rsvpPlan?.data?.benefit_aftertax_amount)} />}
					{rsvpPlan?.data?.deferral_flag && <LabelAndValue label={settings?.afterTaxDeferralPercentLabel} tooltipMessage={settings?.afterTaxDeferralPercentTooltip} value={`${rsvpPlan?.data?.benefit_aftertax_percent}%`} />}
					
					{(rsvpPlan?.data?.loan_count !== null || rsvpPlan?.data?.loan_count !== undefined) && <LabelAndValue label={settings?.numberOfLoansLabel} tooltipMessage={settings?.numberOfLoansHelper} value={rsvpPlan?.data?.loan_count} />}
					{rsvpPlan?.data?.total_loan_amount && <LabelAndValue label={settings?.outstandingLoanAmountLabel} value={getCurrencyFormat(rsvpPlan?.data?.total_loan_amount)} />}
					{rsvpPlan?.data?.total_withdrawal > 0 && <LabelAndValue label={settings?.withdrawalLabel} value={getCurrencyFormat(rsvpPlan?.data?.total_withdrawal)} />}
					{rsvpPlan?.data?.withdrawal_date === YesNoIndicators.Yes && <LabelAndValue label={settings?.withdrawalDateLabel} value={rsvpPlan?.data?.withdrawal_date} />}
					{
						rsvpPlan?.data?.fidelity_link_path &&
						<ContentSpacer>
							<WysiwygWithReactLink content={fidelity} />
						</ContentSpacer>
					}
					{
						rsvpPlan?.data?.plan_details &&
						<button className='link-button' type='button' onClick={() => setOpen(true)}>{settings?.planDetailButtonLabel}</button>
					}
				</DividerSection>
			</>

		);
	};




	return (
		<>
			<PageHeader headerText={settings?.rsvpPlanDetailTitle} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={settings?.rsvpGpsTitle} contents={settings?.rsvpGps} />
				</SideBarContent>
			</Hidden>
			{

				renderDetailSection()
			}
		</>
	);

}

